import { RouteObject } from "react-router-dom";
import { Suspense } from "react";
import AdminLayout from "../layouts/admin/AdminLayout";
import * as LazyComponents from "./lazyComponents";
import LoadingFallback from "../component/atoms/loader/LoadingSpinner";
import ErrorBoundaryWrapper from "../pages/error/ErrorBoundaryWrapper";

export const routes: RouteObject[] = [
  {
    path: "/",
    element: <Suspense fallback={<LoadingFallback />}><LazyComponents.Login /></Suspense>,
    errorElement: <ErrorBoundaryWrapper />,
  },
  {
    path: "/login",
    element: <Suspense fallback={<LoadingFallback />}><LazyComponents.Login /></Suspense>,
    errorElement: <ErrorBoundaryWrapper />,
  },
  {
    path: "/otp-login",
    element: <Suspense fallback={<LoadingFallback />}><LazyComponents.LoginOtp /></Suspense>,
    errorElement: <ErrorBoundaryWrapper />,
  },
  {
    path: "/otp-verification",
    element: <Suspense fallback={<LoadingFallback />}><LazyComponents.OTPVerification /></Suspense>,
    errorElement: <ErrorBoundaryWrapper />,
  },
  {
    path: "/forgot-password",
    element: <Suspense fallback={<LoadingFallback />}><LazyComponents.ForgotPassword /></Suspense>,
    errorElement: <ErrorBoundaryWrapper />,
  },
  {
    path: "/reset-password",
    element: <Suspense fallback={<LoadingFallback />}><LazyComponents.ResetPasswordPage /></Suspense>,
    errorElement: <ErrorBoundaryWrapper />,
  },
  
  {
    path: "/",
    element: <AdminLayout />,
    children: [
      {
        errorElement: <ErrorBoundaryWrapper />,
        children: [
          {
            path: "dashboard",
            element: <Suspense fallback={<LoadingFallback />}><LazyComponents.Dashboard /></Suspense>,
          },
          {
            path: "distributor",
            element: <Suspense fallback={<LoadingFallback />}><LazyComponents.Distributor /></Suspense>,
          },
          {
            path: "distributor/form",
            element: <Suspense fallback={<LoadingFallback />}><LazyComponents.DistributorForm /></Suspense>,
          },
          {
            path: "distributor/view",
            element: <Suspense fallback={<LoadingFallback />}><LazyComponents.DistributorView /></Suspense>,
          },
          {
            path: "distributor/orders/:name",
            element: <Suspense fallback={<LoadingFallback />}><LazyComponents.DistributorOrder /></Suspense>,
          },
          {
            path: "payment",
            element: <Suspense fallback={<LoadingFallback />}><LazyComponents.Payment /></Suspense>,
          },
          {
            path: "profile",
            element: <Suspense fallback={<LoadingFallback />}><LazyComponents.Profile /></Suspense>,
          },
          {
            path: "policies",
            element: <Suspense fallback={<LoadingFallback />}><LazyComponents.Policies /></Suspense>,
          },
          {
            path: "policies/form",
            element: <Suspense fallback={<LoadingFallback />}><LazyComponents.PolicyForm /></Suspense>,
          },
          {
            path: "promo",
            element: <Suspense fallback={<LoadingFallback />}><LazyComponents.Promo /></Suspense>,
          },
          {
            path: "new-versions",
            element: <Suspense fallback={<LoadingFallback />}><LazyComponents.NewVersion /></Suspense>,
          },
          {
            path: "app-updates",
            element: <Suspense fallback={<LoadingFallback />}><LazyComponents.AppUpdate /></Suspense>,
          },
          {
            path: "server",
            element: <Suspense fallback={<LoadingFallback />}><LazyComponents.Server /></Suspense>,
          },
          {
            path: "server-monitoring",
            element: <Suspense fallback={<LoadingFallback />}><LazyComponents.ServerMonitoring /></Suspense>,
          },
          {
            path: "service-type",
            element: <Suspense fallback={<LoadingFallback />}><LazyComponents.ServiceType /></Suspense>,
          },
          {
            path: "tickets",
            element: <Suspense fallback={<LoadingFallback />}><LazyComponents.Tickets /></Suspense>,
          },
          {
            path: "quote",
            element: <Suspense fallback={<LoadingFallback />}><LazyComponents.Quote /></Suspense>,
          },
          {
            path: "lead",
            element: <Suspense fallback={<LoadingFallback />}><LazyComponents.Lead /></Suspense>,
          },
          {
            path: "blog",
            element: <Suspense fallback={<LoadingFallback />}><LazyComponents.Blog /></Suspense>,
          },
        ],
      },
    ],
  },
];